export default "__VITE_ASSET__DiAlxiNA__"